module.exports = __webpack_public_path__ + "static/media/contract.ba55c2c2.svg";